/**
 * SEO metadata only, mirrored from `src/data/parentAssessments.ts`.
 *
 * `src/routes/assessments/$slug.tsx` only needs a slug, title and blurb for its
 * `head()`. Route heads are critical code, so importing the full assessment
 * definitions there dragged all ~33 KB of questions, tips and copy into the
 * shared entry chunk that every visitor — including the landing page — parses.
 *
 * `src/data/__tests__/parentAssessmentMeta.test.ts` fails if this drifts from
 * the real assessment data.
 */
export interface ParentAssessmentMeta {
  slug: string;
  title: string;
  blurb: string;
}

export const PARENT_ASSESSMENT_META: Record<string, ParentAssessmentMeta> = {
  vuca: {
    slug: "vuca-readiness",
    title: "Ready for a changing world",
    blurb:
      "Can your child handle sudden change, unknowns, complex problems and grey areas? The four VUCA skills, observed in everyday moments.",
  },
  communication: {
    slug: "communication",
    title: "How well does your child communicate?",
    blurb:
      "Expressing ideas clearly, really listening, speaking up respectfully, and reading the room — the four habits behind confident communication.",
  },
  empathy: {
    slug: "empathy-kindness",
    title: "Empathy and kindness",
    blurb:
      "Noticing feelings, seeing other points of view, acting kindly without being asked, and including everyone — empathy you can observe.",
  },
  failure: {
    slug: "dealing-with-failure",
    title: "Dealing with failure",
    blurb:
      "Bouncing back, learning from mistakes, persisting through frustration, and keeping setbacks from defining them — resilience in action.",
  },
  growth: {
    slug: "growth-mindset",
    title: "Growth mindset",
    blurb:
      "Does your child believe abilities grow with practice? Beliefs, appetite for challenge, smart effort, and how they take feedback.",
  },
};
